import { createStyles, Theme } from '@material-ui/core'
import { textShadowLogoOnDarkHero, transition } from '../../../shared/style-settings'
import { makeStyles } from '@material-ui/core/styles'

export const useAppHeaderLogoStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      textTransform: 'uppercase',
      fontSize: 18,
      color: 'black',
      fontWeight: 700,
      letterSpacing: 4,
      textDecoration: 'none',
      display: 'inline-flex',
      alignItems: 'center',
      marginRight: 30,

      '& > span': {
        marginLeft: theme.spacing(2),
        transition: transition,
      },

      '&:hover > span': {
        textShadow: textShadowLogoOnDarkHero,
      },

      '& > svg': {
        height: 40,
        width: 40,
      },

      [theme.breakpoints.down('md')]: {
        fontSize: 15,

        '& > span': {
          marginLeft: theme.spacing(1.5),
        },

        '& > svg': {
          height: 35,
          width: 35,
        },
      },

      [theme.breakpoints.down(460)]: {
        marginRight: 10,
      },
    },

    resetOffset: {
      marginRight: 0,
    },

    logo: {
      [theme.breakpoints.down('xs')]: {
        display: 'none',
      },
    },

    logoMini: {
      display: 'none',
      [theme.breakpoints.down('xs')]: {
        display: 'block',
      },
    },
    /** Full wordmark (white) on narrow screens when AppBar is primary */
    logoMiniWordmark: {
      display: 'none',
      maxWidth: 200,
      height: 'auto',
      [theme.breakpoints.down('xs')]: {
        display: 'block',
      },
    },
  })
)
